import Enumerable from "linq";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { AccessType, OptionalColumnEnum, Scope } from "../../common/enums/DRCXEnums";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { AccessPermission, IAccessPermission } from "../../common/models/AccessPermission";
import { IBaseGridColumnDefinition } from "../../common/models/BaseGridColumnDefinition";
import { IDRCXConfigurationBase } from "../../common/models/drcx/IDRCXConfigurationBase";
import { UILanguage } from "../../common/enums/UILanguage";

export interface IGetReportQueryParams {
    beginDate?: Date;
    disableDeferredData?: boolean;
    endDate?: Date;

    softDelete?: boolean;
}

export interface IReportModel {
    id: number;
    reportName: string;
    reportData: Array<IReportDataGridModel>;
    showFooter: boolean;
    pageGridCount: number;
    notificationID: string;
    estimatedDataValues: number;
    exEstimatedDataValues: number;
    ltEstimatedDataValues: number;
    isDataDeferred: boolean;
    isMaxDataValuesExceeded: boolean;
    isMaxRowsExceeded: boolean;
    maxDataValues: number;
    maxRows: number;
}

export interface IReportDataGridModel {
    tableName: string;
    id: number;
    columns: Array<IBaseGridColumnDefinition>;
    rows: Array<IReportDataRow>;
    showFooter: boolean;
}

export interface IReportDataRow {
    rowID: string;
    active: boolean;
    cells: Array<IReportDataCell>;
}

export interface IReportDataCell {
    value?: number;
    displayFormat?: string;
    excelFormat?: string;
    displayText?: string;
    isTextCell?: boolean;
    displayTimestamp?: IDisplayTimestamp;
    optionalColumn?: OptionalColumnEnum;
}

export interface IDisplayTimestamp {
    timestamp: string;
    timeframeType?: TimeframeTypeEnum;
}

export interface IDowloadFileStoreQueryParams {
    filestoreID: number;
}

export interface IReportExportOptions {
    notificationKey: string;
    mimeType: ApplicationMimeTypesEnum;
    beginDate?: Date;
    endDate?: Date;
}

export interface IReportExportResultsModel
{
    estimatedDataValues: number;
    exEstimatedDataValues: number;
    ltEstimatedDataValues: number;
    estimatedRows: number;
    exEstimatedRows: number;
    ltEstimatedRows: number;
    isMaxDataValuesExceeded: boolean;
    isMaxRowsExceeded: boolean;
    maxDataValues: number;
    maxRows: number;
    sectionNumberExceeded: number;
    sectionNameExceeded: string;
}

export interface IRunReportAdHocOptions {
    configuration: IDRCXConfigurationBase;
    disableDeferredData: boolean;
}

export interface IReportConfigurationDescriptionDTO {
    id?: number;
    name?: string;
    scope?: Scope;
    access?: AccessType;
    ownerId?: number;
    ownerName?: string;
    // sectionCount?: number;
    customCode?: string;
    userPermissions?: Array<IAccessPermission>;

    reportTaskId?: number;
    createdByUserName?: string;
}

export class ReportConfigurationDescriptionModel {
    public static NEW_CONFIGURATION_ID: number = -1;

    public id: number = ReportConfigurationDescriptionModel.NEW_CONFIGURATION_ID;
    public name: string = "New View";
    public scope: Scope = Scope.User;
    public access: AccessType = AccessType.Private;
    public ownerId: number | undefined = undefined;
    public ownerName: string | undefined = undefined;
    public userPermissions: Array<AccessPermission> = new Array<AccessPermission>();
    public customCode: string | undefined;

    public reportTaskId: number | undefined;

    public createdByUserName?: string;

    constructor(dto?: IReportConfigurationDescriptionDTO) {
        if (dto) {
            this.id = dto.id ?? this.id;
            this.name = dto.name ?? this.name;
            this.scope = dto.scope ?? this.scope;
            this.access = dto.access ?? this.access;
            this.ownerId = dto.ownerId ?? this.ownerId;
            this.ownerName = dto.ownerName ?? this.ownerName;
            this.userPermissions = dto?.userPermissions?.map(ap => new AccessPermission(ap)) ?? this.userPermissions;
            this.customCode = dto.customCode;
            this.reportTaskId = dto.reportTaskId;
            this.createdByUserName = dto.createdByUserName;
        }
    }

    public userHasPermission(permission: AccessPermission): boolean {
        return this.userPermissions
            ? Enumerable.from(this.userPermissions).any(p => p.contains(permission))
            : false;
    }

    public toDTO(): IReportConfigurationDescriptionDTO {
        return this._toDTO({});
    }

    protected _toDTO(dto: IReportConfigurationDescriptionDTO): IReportConfigurationDescriptionDTO {
        dto.id = this.id;
        dto.name = this.name;
        dto.scope = this.scope;
        dto.access = this.access;
        dto.ownerId = this.ownerId;
        dto.ownerName = this.ownerName;
        dto.userPermissions = this.userPermissions;
        return dto;
    }
}

export interface IReportConfigurationDataDTO {
    userPermissions?: Array<IAccessPermission>;
    configurations?: Array<IReportConfigurationDescriptionDTO>;
}

export class ReportConfigurationDataModel {
    public userPermissions?: AccessPermission[];
    public configurations?: Array<ReportConfigurationDescriptionModel>;

    constructor(configurationData: IReportConfigurationDataDTO) {
        if (configurationData) {
            this.userPermissions = configurationData.userPermissions?.map((permission: IAccessPermission): AccessPermission => {
                return new AccessPermission(permission);
            });
            this.configurations = configurationData.configurations?.map((configuration: IReportConfigurationDescriptionDTO): ReportConfigurationDescriptionModel => {
                return new ReportConfigurationDescriptionModel(configuration);
            });
        }
    }
}

export interface IGetConfigurationListOptions {
    isMyReports?: boolean;
    showAllConfigs?: boolean;
    includeChildGroups?: boolean;
}

// export interface IReportingConfigurationInfoListModel {
//     //currentConfigID?: number;
//     configInfoList: Array<IReportingConfigurationInfo>;
//     //hasWriteChange: boolean;    

//     getGroupedSelectOptions?(addNewConfigSelection: boolean, defaultConfigID?: number): Array<IGroupedSelectOptionGroup>;
//     isPrivateConfig?(configID: number): boolean;
//     isSharedConfig?(configID: number): boolean;
//     isSharedReadOnlyConfig?(configID: number): boolean;

//     userPermissions: IAccessPermission[];
// }

// export interface IReportingConfigurationInfoListModel2 extends IReportingConfigurationInfoListModel {    
    
// }


// export interface IReportingConfigurationInfoListModel {    
//     userPermissions: IAccessPermission[];

//     //currentConfigID?: number;
//     configInfoList: Array<IReportingConfigurationInfo>;
//     //hasWriteChange: boolean;    

//     getGroupedSelectOptions?(addNewConfigSelection: boolean, defaultConfigID?: number): Array<Models.IGroupedSelectOptionGroup>;
//     isPrivateConfig?(configID: number): boolean;
//     isSharedConfig?(configID: number): boolean;
//     isSharedReadOnlyConfig?(configID: number): boolean;

// }

// export interface IReportingConfigurationInfo {
//     access: AccessType;
//     id: number;
//     name: string;
//     ownerId?: number;
//     ownerName: string;
//     reportTaskId?: number;
//     sectionCount?: number;
//     scope?: Enums.DRCX.Scope;
//     userPermissions: Models.IAccessPermission[];
//     customCode?: string;
// }

// export class ReportingConfigurationInfo implements IReportingConfigurationInfo {
//     access: Enums.PageConfigurationAccessEnum;
//     id: number;
//     name: string;
//     ownerId?: number;
//     ownerName: string;
//     reportTaskId?: number;
//     sectionCount?: number;
//     scope?: Enums.DRCX.Scope;
//     userPermissions: Models.AccessPermission[];
//     customCode?: string;

//     constructor(object?: IReportingConfigurationInfo) {
//         if (object !== undefined && object !== null) {
//             this.access = object.access !== undefined ? object.access : null;
//             this.id = object.id !== undefined ? object.id : null;
//             this.name = object.name !== undefined ? object.name : null;
//             this.ownerId = object.ownerId !== undefined ? object.ownerId : null;
//             this.ownerName = object.ownerName !== undefined ? object.ownerName : null;
//             this.reportTaskId = object.reportTaskId !== undefined ? object.reportTaskId : null;
//             this.sectionCount = object.sectionCount !== undefined ? object.sectionCount : null;
//             this.userPermissions = object.userPermissions
//                 ? object.userPermissions.map((permission: Models.IAccessPermission): Models.AccessPermission => {
//                     return new Models.AccessPermission(permission);
//                 })
//                 : new Array<Models.AccessPermission>();
//             this.scope = object.scope;
//             this.customCode = object.customCode;
//         }
//     }

//     public userHasPermission(permission: Models.AccessPermission): boolean {
//         return Enumerable.from(this.userPermissions).any(p => p.contains(permission));
//     }
// }

// export interface IReportingConfigurationInfoListModel {
//     //currentConfigID?: number;
//     configInfoList: Array<IReportingConfigurationInfo>;
//     //hasWriteChange: boolean;    

//     getGroupedSelectOptions?(addNewConfigSelection: boolean, defaultConfigID?: number): Array<Models.IGroupedSelectOptionGroup>;
//     isPrivateConfig?(configID: number): boolean;
//     isSharedConfig?(configID: number): boolean;
//     isSharedReadOnlyConfig?(configID: number): boolean;
// }

// export class ReportingConfigurationInfoListModel implements IReportingConfigurationInfoListModel {
//     //currentConfigID: number = null;
//     configInfoList: Array<ReportingConfigurationInfo>;
//     //hasWriteChange: boolean = false;

//     constructor(object?: IReportingConfigurationInfoListModel) {

//         if (object !== undefined && object !== null) {
//             //            this.currentConfigID = object.currentConfigID !== undefined ? object.currentConfigID : null;

//             this.configInfoList = object.configInfoList !== undefined ? Enumerable.from(object.configInfoList)
//                 .select((config: IReportingConfigurationInfo): ReportingConfigurationInfo => new ReportingConfigurationInfo(config)).toArray() : null;

//             //            this.hasWriteChange = object.hasWriteChange !== undefined ? object.hasWriteChange : null;
//         }
//     }

//     isPrivateConfig(configID: number): boolean {
//         return Enumerable.from(this.configInfoList).where(c => c.access === Enums.PageConfigurationAccessEnum.Private && c.id === configID).any();
//     }

//     isSharedConfig(configID: number): boolean {
//         return Enumerable.from(this.configInfoList).where(c => c.access === Enums.PageConfigurationAccessEnum.Shared && c.id === configID).any();
//     }

//     isSharedReadOnlyConfig(configID: number): boolean {
//         return Enumerable.from(this.configInfoList).where(c => c.access === Enums.PageConfigurationAccessEnum.SharedReadOnly && c.id === configID).any();
//     }

//     getGroupedSelectOptions(addNewConfigSelection: boolean, defaultConfigID?: number): Array<Models.IGroupedSelectOptionGroup> {

//         let groupedSelectOptionGroups = new Array<Models.GroupedSelectOptionGroup>();

//         if (addNewConfigSelection === true) {
//             groupedSelectOptionGroups.push(new Models.GroupedSelectOptionGroup(
//                 "",
//                 [
//                     new Models.GroupedSelectOption(
//                         -1,
//                         i18n.t("common.configuration.newConfiguration"),
//                         "images/configuration.png"
//                     )
//                 ]
//             ));
//         }

//         //show shared only if they exist
//         if (Enumerable.from(this.configInfoList).where(cfg => cfg.access === Enums.PageConfigurationAccessEnum.Shared).any()) {
//             groupedSelectOptionGroups.push(new Models.GroupedSelectOptionGroup(
//                 i18n.t("common.configuration.sharedConfigurations"),
//                 Enumerable
//                     .from(this.configInfoList)
//                     .where((cfg) => cfg.access === Enums.PageConfigurationAccessEnum.Shared)
//                     .orderBy((cfg) => cfg.name.toLocaleLowerCase())
//                     .select((option) => {
//                         return new Models.GroupedSelectOption(
//                             option.id,
//                             option.name,
//                             null, //option.access === Enums.PageConfigurationAccessEnum.SharedReadOnly ? "images/configuration_readonly.png" : "images/configuration_shared.png"
//                             null,
//                             defaultConfigID && defaultConfigID === option.id ? "DEFAULT" : null,
//                         );
//                     }).toArray()));
//         }

//         //show shared readonly only if they exist
//         if (Enumerable.from(this.configInfoList).where(cfg => cfg.access === Enums.PageConfigurationAccessEnum.SharedReadOnly).any()) {
//             groupedSelectOptionGroups.push(new Models.GroupedSelectOptionGroup(
//                 i18n.t("common.configuration.sharedReadOnlyConfigurations"),
//                 Enumerable
//                     .from(this.configInfoList)
//                     .where((cfg) => cfg.access === Enums.PageConfigurationAccessEnum.SharedReadOnly)
//                     .orderBy((cfg) => cfg.name.toLocaleLowerCase())
//                     .select((option) => {
//                         return new Models.GroupedSelectOption(
//                             option.id,
//                             option.name,
//                             null, //option.access === Enums.PageConfigurationAccessEnum.SharedReadOnly ? "images/configuration_readonly.png" : "images/configuration_shared.png"
//                             null,
//                             defaultConfigID && defaultConfigID === option.id ? "DEFAULT" : null,
//                         );
//                     }).toArray()));
//         }

//         //show private only if they exist
//         if (Enumerable.from(this.configInfoList).where(cfg => cfg.access === Enums.PageConfigurationAccessEnum.Private).any()) {
//             groupedSelectOptionGroups.push(new Models.GroupedSelectOptionGroup(
//                 i18n.t("common.configuration.privateConfigurations"),
//                 Enumerable
//                     .from(this.configInfoList)
//                     .where((cfg) => cfg.access === Enums.PageConfigurationAccessEnum.Private)
//                     .orderBy((cfg) => cfg.name.toLocaleLowerCase())
//                     .select((option) => {
//                         return new Models.GroupedSelectOption(
//                             option.id,
//                             option.name,
//                             null, //"images/configuration.png"
//                             null,
//                             defaultConfigID && defaultConfigID === option.id ? "DEFAULT" : null,
//                         );
//                     }).toArray()));
//         }

//         return groupedSelectOptionGroups;
//     }
// }

// export interface IReportingConfigurationInfoListModel2 extends IReportingConfigurationInfoListModel {    
//     userPermissions: Models.IAccessPermission[];
// }

// export class ReportingConfigurationInfoListModel2 extends ReportingConfigurationInfoListModel implements IReportingConfigurationInfoListModel2 {
//     public userPermissions: Models.AccessPermission[];

//     public constructor(object?: IReportingConfigurationInfoListModel2) {
//         super(object);
//         this.userPermissions = object.userPermissions
//             ? object.userPermissions.map((permission: Models.IAccessPermission): Models.AccessPermission => {
//                 return new Models.AccessPermission(permission);
//             })
//             : new Array<Models.AccessPermission>();
//     }
// }


export enum DeliveryOverrideType
{
    Default,
    ForceEmail,
    ForceFtp,
    NoDelivery
}
  
export interface IScheduledReportOptions
{
    overrideReportDates: boolean;
    startDateOverride: Date | undefined;
    endDateOverride: Date | undefined;
    customerID: number;
    taskIDs: number[];
    includeUnscheduledTasks: boolean;
    deliveryOverrideType: DeliveryOverrideType;
    emailOverrides: string[];
    ftpOverride?: string;
    deleteReportAfterDelivery: boolean;
    disableDBUpdate: boolean;
    isTestMessage?: boolean;
    runKey?: string;
    logPrefix: string;
    outputFormat?: string;
    groupOverrideID?: number;
    tatOverrideID?: number;
    includeSubgroupsWithOverride: boolean;
    languageOverride?: UILanguage;
    timeZoneOverride?: number;
    templatePath?: string;
    emailBody?: string; 
    emailSubject?: string;
    useSingleSchedule: boolean;
}
